/* eslint-disable */
import { useMemo } from "react";
import { ICalendarSelectorGroup } from "../types";

export function useUnselectAll(
  groups: ICalendarSelectorGroup[],
  updateGroups: (groups: ICalendarSelectorGroup[]) => void,
) {
  return useMemo(() => {
    const result: ICalendarSelectorGroup[] = [];
    for (const group of groups) {
      result.push({ ...group, items: group.items.map((x) => ({ ...x, active: false })) });
    }
    if (!groups.some(g => g.items.some(i => i.active && !i.disabled && !i.virtual))) {
      return null;
    }
    return () => updateGroups(result);
  }, [groups]);
}
